import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import utilityService from '../../services/utilityService'

// Async thunks

export const getCompanyInfo = createAsyncThunk('utility/getCompanyInfo', async (_, { rejectWithValue }) => {
    try {
        const response = await utilityService.fetchCompanyInfo(
            {
                showSnackbar: true,
                showSuccessSnackbar: false,
                successMessage: 'Company info fetched successfully!',
                errorMessage: 'Failed to fetch company info'
            }
        )
        return response
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const getTaxReport = createAsyncThunk('utility/getTaxReport', async (taxyear, { rejectWithValue }) => {
    try {
        const response = await utilityService.fetchTaxReport(
            taxyear,
            {
                showSnackbar: true,
                showSuccessSnackbar: true,
                successMessage: 'Earnings report generated successfully!',
                errorMessage: 'Failed to generate earnings report'
            }
        )
        return response
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

// Initial state
const initialState = {
    companyInfo: {},
    taxReport: null,
    loading: {
        companyInfo: false,
        taxReport: false,
    },
    error: {
        companyInfo: null,
        taxReport: null,
    },
}

// Slice
const utilitySlice = createSlice({
    name: 'utility',
    initialState,
    reducers: {
        clearErrors: (state) => {
            state.error = {
                companyInfo: null,
                taxReport: null,
            }
        },
    },
    extraReducers: (builder) => {
        // Fetch company info
        builder
            .addCase(getCompanyInfo.pending, (state) => {
                state.loading.companyInfo = true
                state.error.companyInfo = null
            })
            .addCase(getCompanyInfo.fulfilled, (state, action) => {
                state.loading.companyInfo = false
                state.companyInfo = action.payload
            })
            .addCase(getCompanyInfo.rejected, (state, action) => {
                state.loading.companyInfo = false
                state.error.companyInfo = action.payload
            })
        // Fetch tax report
        builder
            .addCase(getTaxReport.pending, (state) => {
                state.loading.taxReport = true
                state.error.taxReport = null
            })
            .addCase(getTaxReport.fulfilled, (state, action) => {
                state.loading.taxReport = false
                state.taxReport = action.payload
            })
            .addCase(getTaxReport.rejected, (state, action) => {
                state.loading.taxReport = false
                state.error.taxReport = action.payload
            })
    },
})

export const { clearErrors } = utilitySlice.actions

export default utilitySlice.reducer
